"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stability = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Stability = function Stability(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.29,6.18a1.09,1.09,0,0,0,0-.18,1,1,0,0,0-1-1H8.7L8.52,5a1,1,0,0,0-.81,1.16L9,13.23a10.83,10.83,0,0,1,0,3.85l-.13.74a1.1,1.1,0,0,0,0,.18,1,1,0,0,0,1,1h4.54a1,1,0,0,0,.82-1.16L15,17a11.51,11.51,0,0,1,0-4ZM15.3,6l-.18,1H8.87L8.7,6Zm-1.23,6.87a12.29,12.29,0,0,0,0,4.32l.14.81H9.82l.14-.75a11.85,11.85,0,0,0,0-4.2L9.05,8h5.89Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "11.3",
    cy: "10.82",
    r: "0.75"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12.3",
    cy: "13.41",
    r: "0.75"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fillOpacity: "0",
    width: "24",
    height: "24"
  }));
};

exports.Stability = Stability;